import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { AutogenLayoutAuthorizationStatus } from "./autogen/AutogenLayoutAuthorizationStatus";

const viewAuthStatusCodeURL = "lme/dispatch/AuthorizationStatus?mode=update&key=";
const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "authorization_status",
    screenName: "Authorization Status",
    navigateToUrl: viewAuthStatusCodeURL
};

export class AuthorizationStatus extends AutogenLayoutAuthorizationStatus {
    async onLoad() {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
        this.layoutGenericColorPicker.setField(this.mainDataSource, "status_hex_color");
    }
}
